<template>
  <div v-if="ads.length" class="ad-card card-voyage">
    <h2 class="ad__label">{{ $t('ad.label') }}</h2>
    <a :href="ads[0].link" :title="ads[0].title" target="_blank">
      <AdImage :images="ads[0].images" />
    </a>
  </div>
</template>

<script>
import AdImage from '@/components/small/AdImage.vue'

export default {
  name: 'AdCard',
  components: { AdImage },
  props: {
    ads: {
      type: Array,
      required: true,
    },
  },
}
</script>
